import JsonApiObject from '@/_models/JsonApiObject'
import store from '@/store'

const hasBklrModule = (project: null | any) => {
    let result = false
    if (project && project.attributes.bklrId) {
        result = store.getters.hasBklrProject(project.attributes.bklrId)
    }
    return result
}

export { hasBklrModule }
